import CheckBoxOutlineBlankRoundedIcon from "@mui/icons-material/CheckBoxOutlineBlankRounded";
import CheckBoxRoundedIcon from "@mui/icons-material/CheckBoxRounded";
import { Box } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { forwardRef } from "react";
import useColors from "../api/hooks/useColors";

export const CustomCheckbox = forwardRef(function CustomCheckbox(props, ref) {
  return (
    <Checkbox
      ref={ref}
      {...props}
      icon={
        <CheckBoxOutlineBlankRoundedIcon
          sx={{ width: "20px", height: "20px" }}
        />
      }
      checkedIcon={
        <CheckBoxRoundedIcon sx={{ width: "20px", height: "20px" }} />
      }
    />
  );
});

export default function StyledDataGrid({
  pageSizeOptionsOverride = null,
  boxSXProps = {},
  enablePagination = true,
  autoHeight = true,
  ...props
}) {
  const colors = useColors();
  const pageSizeOptions = pageSizeOptionsOverride
    ? pageSizeOptionsOverride
    : [5, 10, 20];

  const updatedInitialState = enablePagination
    ? {
        ...props.initialState,
        pagination: {
          ...props.initialState?.pagination,
          paginationModel: {
            ...props.initialState?.pagination?.paginationModel,
            pageSize: pageSizeOptions[0],
            page: 0,
          },
        },
      }
    : props.initialState;
  const newProps = {
    ...props,
    sx: {
      ...props?.sx,
      "& .MuiDataGrid-cell:focus": {
        outline: "none",
        border: "none",
      },
      "& .MuiDataGrid-cellCheckbox:focus-within": {
        outline: "none",
        border: "none",
      },
      "& .MuiDataGrid-cell .MuiDataGrid-columnHeader": {
        background: colors.common_white,
      },
      "& .MuiDataGrid-columnHeader:focus-within": {
        outline: "none",
        border: "none",
      },
      "& .MuiDataGrid-cell": {
        borderBottom: "none",
      },
      "& .MuiDataGrid-row.Mui-selected": {
        background: "transparent",
      },
      "& .MuiDataGrid-row:hover": {
        background: colors.grey_12percent,
      },
      "& .MuiDataGrid-row.Mui-selected:hover": {
        background: colors.grey_100,
      },
    },
    initialState: updatedInitialState,
  };

  const slots = {
    ...(props.slots || {}),
    baseCheckbox: CustomCheckbox,
  };

  return (
    <Box
      sx={{
        "& .MuiDataGrid-columnHeaders": {
          fontSize: 14,
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: 500,
        },
        "& .MuiDataGrid-cell": {
          fontSize: 12,
          fontWeight: 400,
        },
        "& .MuiDataGrid-row.Mui-selected .MuiCheckbox-root": {
          color: colors.primary_main,
        },
        "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked": {
          color: colors.primary_main,
        },
        borderRadius: 3,
        border: `1px solid #d9d9d9`,
        overflow: "hidden",
        ...boxSXProps,
      }}
    >
      <DataGridPro
        pagination={enablePagination}
        disableColumnMenu
        pageSizeOptions={pageSizeOptions}
        autoHeight={autoHeight}
        rows={newProps.rows}
        columns={newProps.columns}
        disableRowSelectionOnClick
        {...newProps}
        slots={slots}
      />
    </Box>
  );
}
